import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Observable, map } from 'rxjs';
import { PostCarousel } from './post-carousel/post-carousel';
import { PostCarouselMobile } from './post-carousel-mobile/post-carousel-mobile';
import { Button } from '../../../../shared/components/button/button';
import { BlogContentService } from '../../../../shared/services/blog-content.service';
import { IBlogPostMeta } from '../../../../shared/interfaces/blog-post.interface';

const HOME_CAROUSEL_SIZE = 8;

@Component({
  selector: 'app-post-carousel-container',
  imports: [CommonModule, PostCarousel, PostCarouselMobile, Button],
  templateUrl: './post-carousel-container.html',
  styleUrl: './post-carousel-container.scss',
})
export class PostCarouselContainer {
  private blogContent = inject(BlogContentService);
  private router = inject(Router);

  // Latest N posts from our migrated blog data (index.json). Replaces the
  // previous WordPress REST API call. Source for both desktop and mobile carousels.
  public posts$: Observable<IBlogPostMeta[]> = this.blogContent
    .getPosts()
    .pipe(map((posts) => posts.slice(0, HOME_CAROUSEL_SIZE)));

  goToBlog(): void {
    this.router.navigate(['/blog']);
  }
}
